import { v as s, w as r, x as t } from "./youtube-icon-ebGlwlFR.js";
function c(...e) {
  return s(r(e));
}
function i(e) {
  const n = e.as || "section";
  return /* @__PURE__ */ t.jsx(n, { className: c("container h-full p-4 md:p-6", e.className), children: e.children });
}
function l(e) {
  return e.replace(/<style[\s\S]*?<\/style>/gi, " ").replace(/<script[\s\S]*?<\/script>/gi, " ").replace(/<[^>]+>/g, " ").replace(/&nbsp;/gi, " ").replace(/\s+/g, " ").trim();
}
export {
  i as C,
  c,
  l as w
};
